/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Pick_5_NeedInputs */

const en_pc_alt_pick_5_need = /** @type {(inputs: Pc_Alt_Pick_5_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You want a quick job done in a browser tab`)
};

const zh_pc_alt_pick_5_need = /** @type {(inputs: Pc_Alt_Pick_5_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`想在浏览器标签页里快速处理`)
};

/**
* | output |
* | --- |
* | "You want a quick job done in a browser tab" |
*
* @param {Pc_Alt_Pick_5_NeedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_pick_5_need = /** @type {((inputs?: Pc_Alt_Pick_5_NeedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Pick_5_NeedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_pick_5_need(inputs)
	return zh_pc_alt_pick_5_need(inputs)
});
export { pc_alt_pick_5_need as "pc.alt.pick.5.need" }